import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';

import {
  // imgAlimentacion,
  // imgAudios,
  // imgEntrenamiento,
  // imgIconBono,
  imgAceleradores,
} from '../../../Shared/Images/producto2';

// import { resultadoService } from '../../../Services/Form';
import { IProducto } from '../../../Interfaces/IProductos';
import { IResultado } from '../../../Interfaces/IResultado';
import { IUserFromStorage } from '../../../Interfaces/IUser';
import { Tr4inerContainedButton } from '../../../Utils/Button';
// import { IAcelerador } from '../../../Interfaces/IAceleradores';
import { AccionDetalle, TipoAccionDetalle } from '../../../Shared/data/FormReducer';
import Loading from '../../../Utils/Loading';
import ModalMaterialesCopy from '../DialogMateriales';
// import ScrollToBottomFab from '../../FAB/ScrollToBottomFab';
import SwiperResultadosPC from './SwiperResultados/SwiperResultadosPC';
import DialogProductDescription from '../../Dialog/DialogProductDescription';

// import LinkIcon from '@mui/icons-material/Link';
// import FAQ_Fit4 from '../../../Shared/Images/FAQ_Fit4.png';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import { progresosImg } from '../../../Shared/Images/VerPesos';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import AlignHorizontalCenterIcon from '@mui/icons-material/AlignHorizontalCenter';
// import ModalLlenarPesosResultado from '../../ModalLlenarPesosResultado/ModalLlenarPesosResultado';

import 'swiper/css';
import 'swiper/css/pagination';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {
  atrasIcon,
  iconAhorra,
  iconAudios,
  iconEntrenamiento,
  iconMancuerna,
  iconPlanAlimentacion,
  iconPreguntasFrecuentes,
  iconProgreso,
} from '../../../Shared/Images';

interface Props {
  dispatch?: React.Dispatch<AccionDetalle>;
  seconds: number;
  isRutinas: string | null;
  setCurrentItemModal: Dispatch<SetStateAction<'rutinas' | 'alimentacion'>>;
  setLinkPdfAlimentacion: Dispatch<SetStateAction<string>>;
  currentItemModal: 'rutinas' | 'alimentacion';
  linkPdfAlimentacion: string;
  resultado: IResultado;
}

// interface IMateriales {
//   displayPdfAlimentacion: string;
//   displayPdfCardio: string;
//   displayPdfEntrenamiento: string;
//   displayPdfTablaNutricional: string;
// }

function ResultadosPC({
  dispatch,
  seconds,
  isRutinas,
  setCurrentItemModal,
  setLinkPdfAlimentacion,
  currentItemModal,
  linkPdfAlimentacion,
  resultado,
}: Props) {
  const [isLoading, setIsLoading] = useState(false);

  // const [videoActual, setVideoActual] = useState<IVideo>();
  // const [videoID, setVideoID] = useState<number>(0);
  const [arrMateriales, setArrMateriales] = useState<any>();

  let value = localStorage.getItem('user');
  let user: IUserFromStorage = typeof value === 'string' ? JSON.parse(value) : '';

  const navigate = useNavigate();

  const [isCompras, setIsCompras] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [producto, SetProduct] = useState<IProducto>();

  // for pdf
  const [openPDF, setOpenPDF] = useState(false);
  const [pdfLink, setPdfLink] = useState<string>('');
  const [percentage, setPercentage] = useState<number>(0);
  // responsive carousel
  // const responsive = { 600: { items: 1 }, 1000: { items: 1 }, 1240: { items: 4 } };

  // materiales

  const [modalMaterialesAdvice, setModalMaterialesAdvice] = useState<boolean>(false);
  const [modalMaterialCopy, setModalMaterialCopy] = useState<string>('');

  useEffect(() => {
    if (resultado) {
      setArrMateriales([
        {
          title: 'Aceleradores',
          subtitle: 'semana 1 a 4',
          src: resultado.displayPdfEntrenamiento,
          pdf: true,
          pdfLink: resultado.linkPdfEntrenamiento,
          copy: resultado.copyEntrenamiento,
          url: '/aceleradores',
          imgFromProject: imgAceleradores,
        },
        {
          title: 'Tus entrenamientos',
          subtitle: 'semana 1 a 4',
          src: resultado.displayPdfEntrenamiento,
          pdf: true,
          pdfLink: resultado.linkPdfEntrenamiento,
          copy: resultado.copyEntrenamiento,
          url: '/misRutinas',
          imgFromProject: iconEntrenamiento,
        },
        {
          title: 'Plan de alimentación',
          subtitle: `de ${resultado.calorias} calorías`,
          src: resultado.displayPdfAlimentacion,
          pdf: true,
          pdfLink: '',
          copy: resultado.copyAlimentacion,
          url: '/planAlimentacion',
          imgFromProject: iconPlanAlimentacion,
        },
        {
          title: 'Preguntas frecuentes',
          subtitle: 'semana 1 a 4',
          src: resultado.displayPdfEntrenamiento,
          pdf: true,
          pdfLink: resultado.linkPdfEntrenamiento,
          copy: resultado.copyEntrenamiento,
          url: '/preguntasFrecuentes',
          imgFromProject: iconPreguntasFrecuentes,
        },
        {
          title: 'Tu progreso',
          subtitle: ``,
          src: resultado.displayPdfAlimentacion,
          pdf: false,
          url: '/tuProgreso',
          imgFromProject: iconProgreso,
        },
        {
          title: 'Audios semanales',
          subtitle: `de ${resultado.calorias} calorías`,
          src: resultado.displayAudios,
          pdf: false,
          pdfLink: '',
          url: '/podcasts',
          imgFromProject: iconAudios,
        },
        {
          title: 'Ahorra 30% en tu dieta',
          subtitle: ``,
          src: resultado.displayPdfBono,
          pdf: true,
          pdfLink: resultado.linkPdfBono,
          url: resultado.linkPdfBono,
          imgFromProject: iconAhorra,
          pdfBono: true,
        },
        {
          title: 'Tu programa de cardio',
          src: resultado.displayPdfCardio,
          pdfLink: resultado.linkPdfCardio,
        },
        {
          title: 'Tu tabla nutricional',
          src: resultado.displayPdfTablaNutricional,
          pdf: true,
          pdfLink: resultado.linkPdfTablaNutricional,
        },
      ]);
    }
    setPercentage(resultado.porcentajeAvancePorMes);
  }, [resultado]);

  // console.log(resultado);

  useEffect(() => {
    if (seconds < 0) {
      if (modalMaterialesAdvice) {
        if (currentItemModal === 'rutinas') {
          setModalMaterialesAdvice(false);
          navigate('/misRutinas');
        } else {
          window.open(linkPdfAlimentacion, '_blank'); // abre la URL en una nueva pestaña
        }
      }
    }
  }, [seconds]);

  return (
    <>
      {isLoading ? (
        <>
          <Loading />
        </>
      ) : (
        <div>
          <div className="h-[5vh] w-full"></div>

          <div className="flex flex-col justify-center">
            {/*Progress Bar */}
            <div className="m-5 w-[80%] self-center flex flex-col justify-start items-start">
              <div
                className={`flex justify-end transition-all delay-150 duration-300 min-w-fit`}
                style={{ width: `${percentage + 1}%` }}
              >
                <img src={iconMancuerna} alt="" width={50} />
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1 dark:bg-gray-300">
                <div
                  className="bg-gray-600 h-2.5 rounded-full dark:bg-gray-700 transition-all delay-150 duration-300"
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
              <div
                className={`mb-1 flex justify-end text-base font-medium transition-all delay-150 duration-300 dark:text-gray-400`}
                style={{ width: `${percentage + 3}%` }}
              >
                {percentage}% Avance
              </div>
            </div>

            {resultado.mensajeMotivacion ? (
              <div
                className="w-[50%] self-center text-center"
                dangerouslySetInnerHTML={{ __html: resultado.mensajeMotivacion }}
              ></div>
            ) : (
              <div className="w-[50%] self-center text-center">
                <p>
                  <b>¡Empecemos con tu gran cambio!</b> <br /> Acabas de entrar en
                  FIT4CHALLENGE y aquí no perdemos el tiempo. Los próximos 90 días van a
                  transformar tu cuerpo y tu mentalidad por completo. Pero antes, hay un
                  primer paso. Este video es la diferencia entre quedarte igual o
                  finalmente lograrlo. <b> Míralo porque esto lo cambia TODO.</b>
                </p>
              </div>
            )}

            {/* materiales */}

            <div className="mx-4 mt-8">
              <SwiperResultadosPC
                arrMateriales={arrMateriales}
                openPDF={openPDF}
                seconds={seconds}
                setCurrentItemModal={setCurrentItemModal}
                setLinkPdfAlimentacion={setLinkPdfAlimentacion}
                setModalMaterialCopy={setModalMaterialCopy}
                setModalMaterialesAdvice={setModalMaterialesAdvice}
              />
            </div>
          </div>

          <div className="h-[1.5px] w-[95%] ml-8 mb-5 mt-10 bg-gray-300"></div>

          {dispatch && (
            <div>
              <Tr4inerContainedButton
                variant="outlined"
                onClick={() => {
                  if (dispatch) {
                    dispatch({
                      type: TipoAccionDetalle.CHANGE_RESPONDIO,
                      payload: true,
                    });
                    user.respondio = true;
                    const existUser = localStorage.getItem('user');
                    const JsonUser = existUser ? JSON.parse(existUser) : {};
                    const updatedValue = { ...JsonUser, ...user };
                    localStorage.setItem('user', JSON.stringify(updatedValue));
                    navigate('/');
                  }
                }}
              >
                Club tr4iner
              </Tr4inerContainedButton>
            </div>
          )}

          {/* <ScrollToBottomFab /> Botón flotante para hacer scroll hasta el final de la pantalla */}

          {dialogOpen && (
            <DialogProductDescription
              isOpen={dialogOpen}
              isCompras={isCompras}
              setIsOpen={setDialogOpen}
              setIsCompras={setIsCompras}
              producto={producto!}
            />
          )}

          {modalMaterialesAdvice && (
            <ModalMaterialesCopy
              copy={modalMaterialCopy}
              isOpen={modalMaterialesAdvice}
              setIsOpen={setModalMaterialesAdvice}
              timeInSeconds={seconds}
              isRutinas={isRutinas}
            />
          )}
        </div>
      )}
    </>
  );
}

export default ResultadosPC;
